import { Component, OnInit } from '@angular/core';

import { AppData } from '../../services/appdata.service';
import { Global } from '../../services/global.service';
import { InsightService } from 'src/app/services/insight.service';

import { Config } from 'src/app/models/env-vars.model';

@Component({
  selector: 'app-models',
  templateUrl: './models.component.html',
  styleUrls: ['./models.component.css']
})
export class ModelsComponent implements OnInit
{
	config = Config;

	selected_tab: string = 'energy';
	parent_tab: string = 'Models';

	backdrop: boolean = false;

	constructor(
		public global: Global,
		public appData: AppData,
		private insight: InsightService
	)
	{
		
	}

	ngOnInit(): void
	{
		this.appData.set('insight_app', null);
	}

	changeTab(tab: string)
	{
		window.scrollTo(0, 0);
		this.selected_tab = tab;
	};

	changeParentTab(tab: string)
	{
		if(tab == 'Insight')
		{
			this.insight.openInsights();
		}
		else
		{
			this.appData.set('insight_app', null);
		}
		window.scrollTo(0, 0);
	};

	createModel()
	{
		this.appData.set("current_step", "Model details");
		this.global.goToApp('create-model')
	}

	insightSurvey()
	{
		$('.feedback_modal').modal('show');
	}

	filterAccessInsights(app: string)
	{
		this.appData.set('insight_app', app);
	}
}
